import { render, staticRenderFns } from "./ClientDetails.vue?vue&type=template&id=8d2424e4&scoped=true"
import script from "./ClientDetails.vue?vue&type=script&lang=js"
export * from "./ClientDetails.vue?vue&type=script&lang=js"
import style0 from "./ClientDetails.vue?vue&type=style&index=0&id=8d2424e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d2424e4",
  null
  
)

export default component.exports